import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';

import { ChartDefaults } from '../../chart-defaults';
import { UtilizationDonutChartComponent } from './utilization-donut-chart.component';
import { WindowReference } from '../../../utilities/window.reference';


export class UtilizationDonutChartModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
    FormsModule,
  ],
  declarations: [UtilizationDonutChartComponent],
  exports: [UtilizationDonutChartComponent],
  providers: [ChartDefaults, WindowReference]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
